export default __webpack_public_path__ + "static/media/auto-fix.801f7f16.svg";